/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const RadioButton = ({ data, onChange, fees, className }) => {
  const { t: translate } = useTranslation();
  return data.map((item, index) => (
    <div
      key={item.state}
      onClick={() => onChange(item)}
      onKeyDown={() => onChange(item)}
      role="button"
      tabIndex="0"
      className={`radioButton  ${item.selected ? 'active' : ''} container  ${
        index !== 0 && 'mt-3'
      } ${className} p-3 rounded-extra`}>
      <div style={{ minHeight: 36 }} className="d-flex justify-content-between align-items-center">
        <div className="d-flex flex-column mx-2">
          <b className="text-f5 text-dark">{translate(item.state, { fees })}</b>
          {item?.content && <p className="text-f6 text-shadow">{`${translate(item.content)}`}</p>}
        </div>
        <div>
          <input
            onChange={() => {}}
            checked={item.selected}
            className="form-check-input"
            type="radio"
            id={item.content}
          />
        </div>
      </div>
    </div>
  ));
};

export default RadioButton;

RadioButton.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

RadioButton.defaultProps = {
  data: [],
  onChange: () => {},
  className: 'bg-light',
};
